module.exports = __webpack_public_path__ + "img/Simulation-RoofConnector.5b7f95a0.jpeg";